import { addPremiumLabels, selectOptionWithPostID, getCurrentPosition } from "./storeLocator";
import { popupInit } from "./popup";

$(document).ready(function() {
    addPremiumLabels();
    popupInit();

    $('select[name="store_locator_form_store_select"]').on("change", function() {
        selectOptionWithPostID()
        console.log('ID set')
    });

    getCurrentPosition();
});
